module.exports = __webpack_public_path__ + "static/media/ppt-file.594d4984.svg";